/**
 * Grab all data-tracking-* attributes from an element and return key/value array
 *
 * @param   {Object}  el  The html element
 *
 * @return  {Array}      Array of hash values [{key: 'key', value: 'value}, ...]
 */
export function processDataTrackingAttributes(el) {
  if (!el) {
    return {};
  }

  const dataAttributes = {};

  Array.from(el.attributes).forEach(dataAttribute => {
    if (/^data-tracking-/.test(dataAttribute.nodeName)) {
      // Create object with it's name (minus the 'data-tracking-' part), and its value
      const key = dataAttribute.nodeName.replace(/^data-tracking-/, '');
      const value = dataAttribute.nodeValue;

      if (value != '') {
        dataAttributes[key] = value;
      }
    }
  });

  return dataAttributes;
}
